export default __webpack_public_path__ + "static/media/element_15.386917f4.webp";